<template>
  <LoadOnVisible v-on:intersected="loadChartData">
    <b-card no-body>
      <b-card-header>
        <div>
          <b-card-title class="font-weight-bolder mb-1">
            Order On Hold by Reason
          </b-card-title>
          <b-card-sub-title class="mb-25">
            based on internal flags
          </b-card-sub-title>
        </div>
        <span
          class="border badge badge-transparent d-none d-sm-inline-block"
          right
          no-caret
          toggle-class="p-0 mb-25"
          size="sm"
          >currently on hold
        </span>
      </b-card-header>

      <b-card-body>
        <div class="text-center" v-if="isLoadingChartData">
          <b-spinner
            variant="primary"
            class="m-5"
            style="height: 4rem; width: 4rem"
            label="Loading..."
          ></b-spinner>
        </div>
        <!-- apex chart -->
        <vue-apex-charts
          v-else
          ref="chart"
          type="pie"
          height="325"
          class="mt-2 mb-1"
          :options="chartData.chartOptions"
          :series="chartData.series"
        />

        <!-- list group -->
        <div class="pt-25">
          <div
            v-for="(data, index) in chartData.listData"
            :key="index"
            class="d-flex justify-content-between"
            :class="
              index === Object.keys(chartData.listData).length - 1 ? '' : 'mb-1'
            "
          >
            <div class="series-info">
              <feather-icon
                :icon="data.icon"
                size="16"
                class="mr-50"
                :class="data.iconColor"
              />
              <span class="font-weight-bolder">{{ data.text }}</span>
            </div>
            <span>{{ data.result }}</span>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </LoadOnVisible>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { LoadOnVisible } from '@/views/components/custom';
export default {
  components: {
    VueApexCharts,
    LoadOnVisible
  },
  data() {
    return {
      apiChartResponse: null,
      isLoadingChartData: true,
      chartData: {
        series: [1, 1, 1],
        chartOptions: {
          chart: {
            toolbar: {
              show: false
            }
          },
          labels: [],
          dataLabels: {
            enabled: false
          },
          legend: { show: true, align: 'right' },
          stroke: {
            width: 4
          },
          // colors: [
          //   $themeColors.danger,
          //   $themeColors.warning,
          //   $themeColors.primary
          // ]
        }
      }
    };
  },
  created() {
    // subcomponent, do not call common data
  },
  computed: {
  },
  watch: {
    chartData: {
      handler: function(val) {
        // DOM updated
        if (this.$refs.chart) {
          this.$refs.chart.updateSeries(val.series, false, true);
        }
      },
      deep: true
    }
  },
  methods: {
    loadChartData() {
      this.isLoadingChartData = true;
      this.$http
        .post('/api/common/analytics/onhold-reason-orders')
        .then(resp => {
          let dataPoints = [];
          let legendPoints = [];
          let reasonsInList = [];
          this.apiChartResponse = resp.data;
          this.apiChartResponse.items.forEach((it) => {
            if(it.onHoldReason == null) {
              it.onHoldReason = 'Other / External';
            }
            if(reasonsInList.find(a => a.onHoldReason == it.onHoldReason) != null) {
              let itm = reasonsInList.find(a => a.onHoldReason == it.onHoldReason);
              itm.quantity += it.quantity;
            } else {
              reasonsInList.push({
                onHoldReason: it.onHoldReason,
                quantity: it.quantity
              });
            }
          })
          reasonsInList.forEach((it)=> {
            dataPoints.push(it.quantity);
            legendPoints.push(it.onHoldReason+' ('+it.quantity+')');
          });

          this.chartData.series = dataPoints;
          this.chartData.chartOptions.labels = legendPoints;
          this.isLoadingChartData = false;
        })
        .catch(err => {
          this.isLoadingChartData = false;
          this.chartData.series = [0, 0, 0];
        });
    }
  },
  mounted() {
  }
};
</script>
